import { z } from 'zod';
import { dimensionSchema } from './dimension.js';
import { matrixGenerationJobStatusSchema } from './matrix-generation.js';

/**
 * Async job that generates a brand-new dimension's 8 cells (2026-08-18
 * matrix-view grill, point 14). Mirrors `matrixGenerationJobSchema`'s shape
 * exactly, plus the `dimensionId` it targets — the dimension row itself is
 * created eagerly by the route, before this job even starts (see
 * `generate-dimension-cells.ts`'s doc comment).
 */
export const dimensionGenerationJobSchema = z.object({
  id: z.string().uuid(),
  matrixId: z.string().uuid(),
  dimensionId: z.string().uuid(),
  status: matrixGenerationJobStatusSchema,
  error: z.string().nullable(),
  startedAt: z.string().datetime(),
  finishedAt: z.string().datetime().nullable(),
});
export type DimensionGenerationJob = z.infer<typeof dimensionGenerationJobSchema>;

/** `POST /matrices/:id/dimensions/generation-jobs` — both fields required (point 14). */
export const createDimensionGenerationJobInputSchema = z.object({
  title: z.string().min(1).max(200),
  comment: z.string().min(1).max(2_000),
});
export type CreateDimensionGenerationJobInput = z.infer<
  typeof createDimensionGenerationJobInputSchema
>;

export const createDimensionGenerationJobResultSchema = z.object({
  job: dimensionGenerationJobSchema,
  dimension: dimensionSchema,
});
export type CreateDimensionGenerationJobResult = z.infer<
  typeof createDimensionGenerationJobResultSchema
>;
